module.exports = __webpack_public_path__ + "static/img/downloadLogo.f389d735.png";